import React from "react";
import { Outlet } from "react-router";

import PoppableHeader from "./PoppableHeader";

const PoppableLayout: React.FC = () => {
  return (
    <div>
      <PoppableHeader />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default PoppableLayout;
